const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class UgcCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 20,
        },
        breakpoints: {
          '(min-width: 768px)': {
            loop: true,
            slides: {
              perView: 'auto',
              origin: 'center',
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            loop: true,
            slides: {
              perView: 6,
              origin: 'center',
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('ugc-carousel')) {
  customElements.define('ugc-carousel', UgcCarousel)
}
